
'use strict';

import Loader from '../loader/loader';
import { displayErrors, isValidDetails } from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';

export default class CustomSelectValue {
  constructor() {

	// Display related modal window when clicking on the option to add
	$('.js-custom-value select').on('change', function (e) {
		e.preventDefault();

		let $this = $(this);

		if($this.val() !== 'custom')
			return false;

        //prevent to have 'custom' as selected option
        $this.find('option').attr('selected', false);

		let	modalClass = $this.closest('.js-custom-value').data('modal-class'),
			$modal = $('.' + modalClass),
			$body = $('body');

		$modal.slideDown({
			duration: 500,
			easing: 'easeOutExpo',
			queue: false,
			complete: function () {
				$body.addClass('fixed');
			}
		});

	});

	/* Make API call to set new select value. */
    $('.js-new-custom-value').on('click', function (e){
        e.preventDefault();

        let $this = $(this),
            $form = $this.closest('.form'),
            $requiredInputs = $form.find('input, select').filter('[required]:visible'),
            inputId = $this.data('input'),
            $input = $('#' + inputId),
            propertyName = $this.data('property'),
            token = $this.parent().find('input[name=__RequestVerificationToken]').val(),
            apiUrl = $this.data('api'),
            loader = new Loader(),
            dataParams = {};

        let isBrand = inputId === 'NewBrand';

        let $errorContainer = $this.parent().parent().siblings('.server-errors__wrap');

        //prevent API call if required input are empty
        if(isValidDetails($requiredInputs))
            $this.removeClass('error');
        else{
            $this.addClass('error');
            return false;
        }

        loader.fadeIn();

        //define Obj as property name changes according to input
        dataParams[propertyName] = $input.val();

        //Brand is associated to a category.
        if(isBrand)
            dataParams.Category = $('#ProductCategory').val();

        $.ajax({
            url: apiUrl,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            headers: { __RequestVerificationToken: token },
            data: JSON.stringify(dataParams),
            success: function (data) {

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

                toaster( 'Details have been saved!');

                displayNewOptionValue(data);

                //close modal window
                $('.js-collapse-form-modal').trigger('click');

                loader.fadeOut();
            },
            error: function (error) {

                loader.fadeOut();
                displayErrors(error, $errorContainer );
            }
        });
    });

    let displayNewOptionValue = function(data){
        if (data.length === 0 )
            return false;

        let $select = $('#' + data.Id);

        $select.append(
            $('<option></option>')
                .text(data.Text)
                .val(data.Value)
                .attr('selected', true)
        );

        $select.trigger('change')
    };

  }
}
